<div class="row align-items-end">
  <div class="col-6">
    <h2>Temas</h2>
  </div>
  <div class="col-6 text-end"><button class="btn btn-sm btn-success" (click)="open(content)"><i
  class="bi bi-file-earmark-plus"></i>Novo</button></div>
</div>
<table mat-table [dataSource]="dataSource" matSort class="mt-2">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Id
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
    {{element.id}} </td>
  </ng-container>
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Nome"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Nome
    </th>
    <td mat-cell *matCellDef="let element">
    {{element.nome}} </td>
  </ng-container>
  <ng-container matColumnDef="urlCurta">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Url Curta"
      class="d-none d-lg-block d-xl-none">
      Url Curta
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
    {{element.urlCurta}} </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-sm" (click)="edit(content,row.id)"><i class="bi bi-pen-fill"></i></button>
        <button class="btn btn-sm" (click)="deleteItem(row.id)"><i class="bi bi-trash"></i></button>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
</mat-paginator>

<ng-template #content let-c="close" let-d="dismiss">
  <form (ngSubmit)="submitForm()" novalidate [formGroup]="formTema">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Tema</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Nome</label>
        <input id="nome" formControlName="nome" type="text" class="form-control" />
        @if (submitted && f.nome.errors) {
          <small class="text-danger">
            @if (f.nome.errors.required) {
              <span>Nome é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Url Curta</label>
        <input id="urlCurta" formControlName="urlCurta" type="text" class="form-control" />
        @if (submitted && f.urlCurta.errors) {
          <small class="text-danger">
            @if (f.urlCurta.errors.required) {
              <span> Url Curta é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Observação</label>
        <textarea id="obs" formControlName="obs" type="text" class="form-control" rows="5"></textarea>
        @if (submitted && f.obs.errors) {
          <small class="text-danger">
            @if (f.obs.errors.required) {
              <span>Observação é obrigatório.</span>
            }
          </small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
      <input type="hidden" name="acao" />
      <input type="hidden" name="id" id="id" formControlName="id" />
    </div>
  </form>
</ng-template>